const escapeRegExp = (value: string): string => value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

export const stripFolderPathFromMessage = (message: string, folderPath: string): string => {
  if (!folderPath || !message.includes(folderPath)) return message;

  const pattern = new RegExp(`\\s*:\\s*['"]?${escapeRegExp(folderPath)}['"]?`);
  return message.replace(pattern, '').replace(/\s{2,}/g, ' ').trim();
};
